<template>
    <div class="main-container col-xs-12">
        <bread-crumb :items="managePersonBreadCrumbPath" />
        <v-divider height="12px" />
        <div
            class="row"
            v-cloak
        >
            <div
                class="col main-content op"
                data-ride="carousel"
            >
                <div
                    class="offset-xs-4 col-xs-4"
                    v-if="loading"
                >
                    <cube-shadow
                        background="#295e89"
                        shadow="#cc0000"
                    />
                </div>
                <div v-else>
                    <v-tabs
                        :value="activeTab"
                        color="primary"
                        height="40px"
                        slider-color="#fdd835"
                        v-if="personId"
                    >
                        <v-tab
                            key="0"
                            ripple
                        >
                            <i class="fas fa-info-circle pr-1" />&nbsp;Summary
                        </v-tab>
                        <v-tab-item key="0">
                            <person-summary :person-id="personId" />
                        </v-tab-item>

                        <v-tab
                            key="1"
                            ripple
                        >
                            <i class="fas fa-address-card pr-1" />Address
                        </v-tab>
                        <v-tab-item key="1">
                            <person-address :person-id="personId" />
                        </v-tab-item>

                        <v-tab
                            key="2"
                            ripple
                        >
                            <i class="fas fa-phone pr-1" />Phone Numbers
                        </v-tab>
                        <v-tab-item key="2">
                            <phone-number :person-id="personId" />
                        </v-tab-item>

                        <v-tab
                            key="3"
                            ripple
                        >
                            <i class="fas fa-users pr-1" />&nbsp;Team
                        </v-tab>
                        <v-tab-item key="3">
                            <person-team :person-id="personId" />
                        </v-tab-item>

                        <v-tab
                            key="4"
                            ripple
                        >
                            <i class="fas fa-briefcase pr-1" />&nbsp;Employment
                        </v-tab>
                        <v-tab-item key="4">
                            <employment :person-id="personId" />
                        </v-tab-item>

                        <v-tab
                            key="5"
                            ripple
                        >
                            <i class="fas fa-car pr-1" />&nbsp;Vehicles
                        </v-tab>
                        <v-tab-item key="5">
                            <vehicle :person-id="personId" />
                        </v-tab-item>

                        <!-- <v-tab
                            :class="{ holidayWarning: person.holidayEntitlements && !person.holidayEntitlements.length }"
                            key="6"
                            ripple
                        >
                            <i class="fas fa-plane pr-1" />&nbsp;Holiday
                        </v-tab>
                        <v-tab-item key="6">
                            <holiday :person-id="personId" />
                        </v-tab-item> -->
                        
                        <v-tab
                            :class="{ availabilityWarning: person.availability && !person.availability.length }"
                            key="6"
                            ripple
                        >
                            <i class="fas fa-building pr-1" />&nbsp;Availability
                        </v-tab>
                        <v-tab-item key="6">
                            <availability :person-id="personId" />
                        </v-tab-item>

                        <v-tab
                            key="7"
                            ripple
                        >
                            <i class="fas fa-briefcase-medical pr-1" />&nbsp;Emergency Contact
                        </v-tab>
                        <v-tab-item key="7">
                            <emergency-contact :person-id="personId" />
                        </v-tab-item>

                        <v-tab
                            key="8"
                            ripple
                        >
                            <i class="fas fa-warehouse pr-1" />&nbsp;Assets
                        </v-tab>
                        <v-tab-item key="8">
                            <person-asset :person-id="personId" />
                        </v-tab-item>
                        
                        <v-tab
                            key="9"
                            ripple
                        >
                            <i class="fas fa-certificate pr-1" />&nbsp;Training
                        </v-tab>
                        <v-tab-item key="9">
                            <person-course :person-id="personId" />
                        </v-tab-item>
                    </v-tabs>
                    <h3
                        class="text-center"
                        v-if="person && person.length > 0"
                    >
                        {{ person[0].name }}</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PersonAddress from '@/views/ManagePersonnel/components/PersonAddress/PersonAddress.vue';
import PersonAsset from '@/views/ManagePersonnel/components/PersonAsset/PersonAsset.vue';
import Availability from '@/views/ManagePersonnel/components/PersonAvailability/Availability.vue';
import PersonCourse from '@/views/ManagePersonnel/components/PersonCourse/PersonCourse.vue';
import EmergencyContact from '@/views/ManagePersonnel/components/PersonEmergencyContact/EmergencyContact.vue';
import Employment from '@/views/ManagePersonnel/components/PersonEmployment/Employment.vue';
import PhoneNumber from '@/views/ManagePersonnel/components/PersonPhoneNumber/PhoneNumber.vue';
import PersonSummary from '@/views/ManagePersonnel/components/PersonSummary/PersonSummary.vue';
import PersonTeam from '@/views/ManagePersonnel/components/PersonTeam/PersonTeam.vue';
import Vehicle from '@/views/ManagePersonnel/components/PersonVehicle/Vehicle.vue';

import { FETCH_ASSET_STATUS_LIST } from "@/store/asset_status/actions";
import { FETCH_ASSET_TYPE_LIST } from "@/store/asset_type/actions";
import { FETCH_COURSE_TYPE_LIST } from "@/store/course_type/actions";
import { FETCH_CURRENCY_LIST, } from "@/store/currency/actions";
import { FETCH_ECS_COMPANY_LIST } from "@/store/ecs_company/actions";
import { FETCH_EMPLOYMENT_TYPES } from "@/store/employment_type/actions";
import { FETCH_JOB_LIST } from "@/store/job/actions";
import { FETCH_PERSON, FETCH_PERSONNEL } from "@/store/person/actions";
import { FETCH_PERSONNEL_COUNTRY_LIST } from "@/store/personnel_country/actions.js";
import { FETCH_TEAM_LIST, } from "@/store/team/actions";
import { mapGetters } from "vuex";

    export default {
        name: "ManagePerson",
        components: {
            PersonAddress,
            PhoneNumber,
            PersonSummary,
            Vehicle,
            EmergencyContact,
            Employment,
            PersonTeam,
            PersonAsset,
            Availability,
            PersonCourse
        },
        data: function () {
            return {
                loading: false,
                personId: '',
                activeTab: 0,
            };
        },
        computed:
        {
            ...mapGetters(
            [
                "userPermissions",
                "person",
                "isContractor",
            ]
            ),
            managePersonBreadCrumbPath() {
                let newBreadCrumbPath = [
                    {
                        text: 'Manage Personnel',
                        to: '/manage-personnel',
                        disabled: false,
                    }];
                const personObject = {};
                const link = `/manage-personnel/${this.person.personId}`;
                personObject.text = this.person.name;
                personObject.disabled = false;
                personObject.to = link;
                newBreadCrumbPath.push(personObject);
                return newBreadCrumbPath;
            }
        },

        mounted() {
            this.fetchEcsCompanies();
            this.fetchEmploymentTypes();
            this.fetchJobs();
            this.fetchPersonnel();
            this.fetchPersonnelCountryList();
            this.fetchAssetTypeList();
            this.fetchAssetStatusList();
            this.fetchTeams();
            this.fetchCurrencyList();
            this.fetchCourseTypeList();

            if (this.$route.params !== undefined) {
                if (this.$route.params.personId !== undefined) {
                    this.personId = Number.parseInt(this.$route.params.personId);
                }
                if (this.$route.params.subView !== undefined) {
                    const routeSubView = this.$route.params.subView;
                    switch (routeSubView) {
                        case 'vehicles' :
                            this.activeTab = 3;
                            break;
                        case 'availability' :
                            this.activeTab = 4;
                            break;
                        default:
                            this.activeTab = 0;
                            break;
                    }
                }
            }

            if (this.personId > 0) {
                this.fetchPerson();
            }
        },

        methods: {
            fetchPersonnel() {
                this.$store.dispatch(FETCH_PERSONNEL);
            },
            fetchEmploymentTypes() {
                this.$store.dispatch(FETCH_EMPLOYMENT_TYPES);
            },
            fetchEcsCompanies() {
                this.$store.dispatch(FETCH_ECS_COMPANY_LIST);
            },
            fetchJobs() {
                this.$store.dispatch(FETCH_JOB_LIST);
            },
            fetchPerson() {
                this.$store.dispatch(FETCH_PERSON, this.personId);
            },
            fetchPersonnelCountryList() {
                this.$store.dispatch(FETCH_PERSONNEL_COUNTRY_LIST);
            },
            fetchTeams() {
                this.$store.dispatch(FETCH_TEAM_LIST);
            },
            updateCurrentPerson(personId) {
                this.personId = personId;
                this.$router.push({name: 'manage person', params: {personId}});
                this.fetchPerson();
            },
            fetchAssetTypeList() {
                this.$store.dispatch(FETCH_ASSET_TYPE_LIST);
            },
            fetchCourseTypeList() {
                this.$store.dispatch(FETCH_COURSE_TYPE_LIST);
            },
            fetchAssetStatusList() {
                this.$store.dispatch(FETCH_ASSET_STATUS_LIST);
            },
            fetchCurrencyList() {
                this.$store.dispatch(FETCH_CURRENCY_LIST);
            },
        },
    }
</script>